import jwt_decode from "jwt-decode";

const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const EXP_TOKEN_KEY = "expiration";

const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  getAuthorization() {
    const tokenData = localStorage.getItem('TOKEN_KEY');
  
    if (!tokenData) return "";
  
    try {
      const parsedToken = JSON.parse(tokenData); 
      return parsedToken.token ? `Bearer ${parsedToken.token}` : "";
    } catch (error) {
      console.error("Erreur de parsing du token:", error);
      return "";
    }
  },  

  saveToken(accessToken) {
    const TOKEN_LIFE = 24 * 60 * 60 * 1000;
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(EXP_TOKEN_KEY, new Date().getTime() + TOKEN_LIFE);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  removeToken2() {
    localStorage.removeItem("TOKEN_KEY");
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  getTokenInfo() {
    const token = localStorage.getItem(TOKEN_KEY);
    if (typeof token !== "string") return {};
    const decoded = jwt_decode(token);
    console.log(decoded);
    console.log(new Date(decoded.exp));
    return decoded;
  },

  isUserLogined() {
    if (localStorage.getItem("TOKEN_KEY") == null) return false;
    const token = JSON.parse(localStorage.getItem("TOKEN_KEY"));
    // console.log(token.token);
    if (typeof token !== "object") return false;
    const decoded = jwt_decode(token.token);
    // console.log(decoded)
    // console.log(new Date(decoded.exp))
    const expDate = new Date(0);
    expDate.setUTCSeconds(decoded.exp);
    console.log(expDate.getTime() > new Date().getTime());
    return expDate.getTime() > new Date().getTime();
    // return token
  },
};

export { TokenService };
